import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row, Tooltip, OverlayTrigger } from 'react-bootstrap';
import classNames from 'classnames';
import { useGetDta } from '../../../hooks/useGetDta';
import LoadinSpin from '../../ui/LoadinSpin';
import { headTbl } from '../../../data/tables';
import Table from '../../Table';
import { useContextInfo } from '../../../context/ContextInfo';
import { fetchConToken } from '../../../api/fetch';
import { AuthContext } from '../../../auth/AuthContext';
import ModCancelFac from './ModCancelFac';
import { checkAccess } from '../../../helpers/details';
const baseUrl = process.env.REACT_APP_API;

const FacSatUs = ({ activo, activeTab }) => {
    const { id } = useParams();
    let idR = atob(id);
    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Facturación', auth.accesos);
      const {
          
          fact_cancelar,
          fact_enviar_email,
           } = permisos.functions

    const [show, setShow] = useState(false);
    const [fac, setFac] = useState({});
    const { setResp } = useContextInfo();
    const { loading, data, getInfo } = useGetDta(`factura/myfacelectro/${idR}`);
    useEffect(() => {
        getInfo(`factura/myfacelectro/${idR}`);
    }, [idR, activeTab, activo]);

    const cancel = (payload) => {
        setFac(payload);
        setShow(true);
    };
    const sendFac = async (payload) => {
        let res = await fetchConToken(
            `factura/sendemail`,
            { idus: payload.idus, fcId: payload.fcId, email: payload.correo },
            'PUT'
        );
        setResp(res);
    };
    const download = (rut, name) => {
        const xml = baseUrl + rut;
        fetch(xml)
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${name}.xml`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            });
    };
    const StatusColumn = ({ row }) => {
        return (
            <>
                <span
                    className={classNames('badge', {
                        'bg-success': row.original.state === '',
                        'bg-warning': row.original.state === 'pending',
                        'bg-danger': row.original.state === 'canceled',
                    })}>
                    {row.original.state === 'canceled' && 'CANCELADO'}
                    {row.original.state === 'pending' && 'PENDIENTE'}
                    {row.original.state === '' && 'VÁLIDO'}
                </span>
            </>
        );
    };
    const RazonColumn = ({ row }) => {
        return <div style={{ whiteSpace: 'pre-line' }}>{row.original.razon}</div>;
    };
    const ActionColumn = ({ row }) => {
        return (
            <>
                {row.original.state !== `canceled` && fact_cancelar && (
                    <OverlayTrigger
                        className="action-icon "
                        placement="left"
                        overlay={<Tooltip id="overlay-example"> Cancelar /Anular factura</Tooltip>}>
                        <i className="mdi mdi-cancel mdi-18px " onClick={() => cancel(row.original)}></i>
                    </OverlayTrigger>
                )}

                {fact_enviar_email&& (
                    <OverlayTrigger
                        placement="left"
                        overlay={<Tooltip id="overlay-example"> Enviar por correo al cliente</Tooltip>}>
                        <i className="mdi mdi-email mdi-18px " onClick={() => sendFac(row.original)}></i>
                    </OverlayTrigger>
                )}

                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example"> Ver pdf</Tooltip>}>
                    <a target="_blank" href={baseUrl + row.original.rut} rel="noopener noreferrer">
                        {' '}
                        <i className="mdi mdi-file-pdf-box mdi-18px "></i>
                    </a>
                </OverlayTrigger>
                <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example">Descargar XML</Tooltip>}>
                    <i
                        className="mdi mdi-file-excel-outline mdi-18px "
                        onClick={() => download(row.original.rut.replace('.pdf', '.xml'), row.original.folio)}
                    />
                </OverlayTrigger>
            </>
        );
    };
    const columns = [
        {
            Header: 'Fecha',
            accessor: 'fecha',
            sort: true,
        },
        {
            Header: 'Nombre',
            accessor: 'nombre',
            sort: true,
        },

        {
            Header: 'Razón',
            accessor: 'razon',
            sort: true,
            Cell: RazonColumn,
        },

        {
            Header: 'Rfc',
            accessor: 'rfc',
            sort: true,
        },

        {
            Header: 'folio',
            accessor: 'folio',
            sort: true,
        },
        {
            Header: 'total',
            accessor: 'total',
            sort: true,
        },

        {
            Header: 'Estado',
            accessor: 'state',
            sort: true,
            Cell: StatusColumn,
        },
        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    if (loading) return <LoadinSpin />;
    return (
        <div className="p-2">
            {' '}
            <Row>
                <Col>
                    <Table
                        columns={columns}
                        data={data}
                        pageSize={25}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        searchBoxClass="mb-2"
                    />
                </Col>
            </Row>
            <ModCancelFac callBk={getInfo} show={show} onClose={() => setShow(false)} data={fac} />
        </div>
    );
};

export default FacSatUs;
